
const state = {
  isModalOpen: false,
  uploadProgress: 0,

};

const mutations = {
  toggleModal(state) {
    state.isModalOpen = !state.isModalOpen;
  },
  setUploadProgress(state, progress) {
    state.uploadProgress = progress;
  },
};

const actions = {
  toggleModal({ commit }) {
    commit('toggleModal');
  },
  setUploadProgress({ commit }, progress) {
    commit('setUploadProgress', progress);
  },

};

const getters = {
  isModalOpen: state => state.isModalOpen
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
